import { render } from "./GalleryItem.vue?vue&type=template&id=533a64a0&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"

import "./GalleryItem.vue?vue&type=style&index=0&id=533a64a0&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533a64a0"]])

export default __exports__